// forum-category — 论坛分类筛选纯逻辑(便于单测,与 React 解耦)。
//
// 根因背景:文章 category_id 存的是 L2 叶子;点 L1 仅得 L1 id,精确匹配 0 条。
// 此函数把「当前选中的 category_id」解析为「应纳入 feed 的 category_id 集合」:
//   - 选中 L2 叶子 → [该 L2]
//   - 仅选 L1     → [L1 本身, ...其全部 L2 子类](含 L1 兜底直挂文章)
//   - 全部 / 未匹配 → undefined(调用方据此不传过滤;未加载场景由 query enabled 兜底)

export type CatTreeNode = { id: string; children: { id: string }[] }

export function resolveFeedCategoryIds(
  tree: CatTreeNode[],
  categoryId: string | null,
): string[] | undefined {
  if (!categoryId) return undefined
  const l1 = tree.find((n) => n.id === categoryId)
  if (l1) return [l1.id, ...l1.children.map((c) => c.id)]
  const parent = tree.find((n) => n.children.some((c) => c.id === categoryId))
  if (parent) return [categoryId]
  return undefined
}
